import { render } from "./HorizontalNavWithAnchorLinks.vue?vue&type=template&id=29373131"
import script from "./HorizontalNavWithAnchorLinks.vue?vue&type=script&lang=js"
export * from "./HorizontalNavWithAnchorLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__